import React, { PropsWithChildren, Ref } from 'react';
import { useDragAndDrop } from '../../../../../../_lib/DragAndDrop';

type FormsComboboxMultiSelectListElementType = PropsWithChildren<{
  ref?: Ref<any>;
  id: string;
  moveItem: (sourceId: string, targetId: string) => void;
  dragItemPreview: React.ElementType<any>,
  dragItemPreviewProps: any,
  onAnimationEnd?: (event: React.AnimationEvent<HTMLLIElement>) => void;
}>;

export function FormsComboboxDraggableMultiSelectListElement({
  ref,
  id,
  moveItem,
  dragItemPreview,
  dragItemPreviewProps,
  onAnimationEnd,
  children,
}: FormsComboboxMultiSelectListElementType) {
  const { isDragging, onDragStart, onDragEnter, onDragOver, onDragEnd } = useDragAndDrop(
    id,
    moveItem,
    dragItemPreview,
    dragItemPreviewProps,
  );

  return (
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <li
      ref={ref}
      onAnimationEnd={onAnimationEnd}
      className={`forms-combobox-multiselect__list-item${isDragging
        ? ' forms-combobox-multiselect__list-item--dragging'
        : ''} `}
      onDragStart={onDragStart}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
      draggable
    >
      {children}
    </li>
  );
}
